/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    tooltip: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    tooltip: false,
};

const FormHelp = (props) => {
    const classNames = [
        'c-form__help',
        props.tooltip ? 'c-tooltip-container c-tooltip-container--hover' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

FormHelp.propTypes = propTypes;

FormHelp.defaultProps = defaultProps;

export default FormHelp;
